import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-secure-payment',
  templateUrl: './secure-payment.component.html',
  styleUrls: ['./secure-payment.component.css']
})
export class SecurePaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
